"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_crud_client_1 = require("./new.crud.client");
class PartnerClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v1/partners';
    }
    getUsersByPartner(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { partnerId } = request;
            const response = yield this.httpGet(`/v1/partners/${partnerId}/users?${this.getQueryString(request)}`);
            return response.payload || [];
        });
    }
    getAccountsByPartner(partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/partners/${partnerId}/accounts`);
            return response.payload || [];
        });
    }
    getProjects(partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/partners/${partnerId}/projects`);
            return response.payload || [];
        });
    }
    getPartnerUsersByProjectId(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/partners/projects/${projectId}/users`);
            return response.payload || [];
        });
    }
}
exports.PartnerClient = PartnerClient;
//# sourceMappingURL=partner.client.js.map